var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#E7F8FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2938_2910",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 105,
    height: 105
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.2764 65.0098L70.3154 68.9307H51.6846L49.7236 65.0078H39.918C39.5313 65.0079 39.1485 65.0843 38.7914 65.2324C38.4342 65.3806 38.1098 65.5977 37.8366 65.8713C37.5635 66.145 37.3469 66.4698 37.1993 66.8271C37.0517 67.1845 36.9761 67.5675 36.9766 67.9541V79.7188C36.9768 80.4988 37.2868 81.2468 37.8384 81.7984C38.3899 82.3499 39.1379 82.6599 39.918 82.6602H82.082C82.8621 82.6599 83.6101 82.3499 84.1616 81.7984C84.7132 81.2468 85.0232 80.4988 85.0234 79.7188V67.9541C85.0234 67.1739 84.7136 66.4256 84.162 65.8739C83.6104 65.3221 82.8622 65.012 82.082 65.0117L72.2764 65.0098Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2959 73.835H50.7041C49.6211 73.835 48.7432 74.7129 48.7432 75.7959C48.7432 76.8789 49.6211 77.7568 50.7041 77.7568H71.2959C72.3789 77.7568 73.2568 76.8789 73.2568 75.7959C73.2568 74.7129 72.3789 73.835 71.2959 73.835Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2568 41.4766H77.6904C78.3742 41.4767 79.0366 41.7151 79.5638 42.1506C80.091 42.5862 80.45 43.1918 80.5791 43.8633L85.0234 66.9707",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9766 66.9707L41.4199 43.8633C41.5346 43.2673 41.8307 42.7215 42.2678 42.3005C42.7049 41.8795 43.2615 41.604 43.8613 41.5117L48.7441 41.502",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8594 65.0098V60.9082C42.8594 60.5219 42.9355 60.1393 43.0834 59.7824C43.2313 59.4254 43.448 59.1011 43.7212 58.828C43.9945 58.5548 44.3189 58.3382 44.6758 58.1904C45.0328 58.0427 45.4154 57.9667 45.8018 57.9668H76.1982C76.5846 57.9667 76.9672 58.0427 77.3242 58.1904C77.6811 58.3382 78.0055 58.5548 78.2788 58.828C78.552 59.1011 78.7687 59.4254 78.9166 59.7824C79.0645 60.1393 79.1406 60.5219 79.1406 60.9082V65.0098",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8213 57.9717V54.7031C44.8212 54.3168 44.8971 53.9342 45.0449 53.5772C45.1927 53.2202 45.4093 52.8958 45.6825 52.6226C45.9556 52.3494 46.2799 52.1326 46.6368 51.9847C46.9938 51.8369 47.3763 51.7607 47.7627 51.7607H74.2373C74.6237 51.7607 75.0062 51.8369 75.3632 51.9847C75.7201 52.1326 76.0444 52.3494 76.3175 52.6226C76.5907 52.8958 76.8073 53.2202 76.9551 53.5772C77.1029 53.9342 77.1788 54.3168 77.1787 54.7031V57.9717",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7822 51.7607V48.4922C46.7822 48.1059 46.8583 47.7234 47.0061 47.3666C47.1539 47.0097 47.3706 46.6854 47.6437 46.4123C48.1954 45.8607 48.9435 45.5508 49.7236 45.5508H72.2764C72.6626 45.5508 73.0451 45.6269 73.402 45.7747C73.7589 45.9225 74.0831 46.1392 74.3563 46.4123C74.6294 46.6854 74.8461 47.0097 74.9939 47.3666C75.1417 47.7234 75.2178 48.1059 75.2178 48.4922V51.7607",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7432 45.5508V42.2822C48.7434 41.5022 49.0534 40.7542 49.605 40.2026C50.1565 39.6511 50.9045 39.3411 51.6846 39.3408H70.3154C71.0955 39.3411 71.8435 39.6511 72.395 40.2026C72.9466 40.7542 73.2566 41.5022 73.2568 42.2822V45.5508",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 8.75,
    width: 103.5,
    height: 103.5,
    rx: 51.75,
    stroke: "#0078BB",
    strokeWidth: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2938_2910)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60.5,
    r: 52.5,
    fill: "url(#paint0_linear_2938_2910)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2938_2910",
    x1: 61,
    y1: -12,
    x2: 60.5,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F4F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatInfo);
export default __webpack_public_path__ + "static/media/feat_info.02cc3e1fb91169fac242ee6eb9aef8f8.svg";
export { ForwardRef as ReactComponent };